/**
 * Lockup de marca "T●M" — la O es un punto de color que sigue al color de la
 * palabra. Se usa en el login, el header y el footer del sidebar.
 *   dot:   color del punto (oliva #C3DB5A sobre verde; ámbar #FFC400 en "funciona con")
 *   color: color de las letras T y M
 */
export function TomMark({ fontSize = 28, dot = '#C3DB5A', color = '#fff', className }) {
  return (
    <span
      className={className}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        fontFamily: 'Jost, sans-serif',
        fontWeight: 700,
        color,
        fontSize,
        lineHeight: 1,
      }}
    >
      <span>T</span>
      <span
        style={{
          display: 'inline-block',
          width: '0.62em',
          height: '0.62em',
          borderRadius: '50%',
          background: dot,
          margin: '0 0.04em',
          flex: 'none',
        }}
      />
      <span>M</span>
    </span>
  )
}
